'use client';
import Image from "next/image";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap"; 


export default function ImageModal({ immg, props }: any) {
    const [show, setModal] = useState(false);

    const handleClose = () => {
        setModal(false);
    };
    const handleOpen = () => {
        setModal(true);
    };
    return (
        <>
            {!show ?
                <div className="image-icon" onClick={() => handleOpen()} >
                    <div className="image-vemo-icon venobox vbox-item" ></div>
                </div>
                :
                <Modal
                    {...props}
                    show={show}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header>
                        <Button variant="secondary" onClick={handleClose}>
                            X
                        </Button>
                    </Modal.Header>
                    <Modal.Body>
                        {immg ? <>
                            <Image
                                src={immg?.url}
                                alt={immg?.alternative ?? ''}
                                title={immg?.title ?? ''} 
                                width={immg?.width}
                                height={immg?.height}
                                className={`mw-100 h-auto`}
                                placeholder='blur'
                                blurDataURL={`${process.env.NEXT_PUBLIC_DATA_BLUR_URL}`}
                            />
                        </> : null}
                    </Modal.Body>
                </Modal>
            }
        </>
    )
}